<template>
  <page-layout
    :header="isMobile"
    :loaded="currentUserLoaded"
    title="Recruiting Dashboard"
  >
    <div class="content-main">
      <div class="content-main__centered">
        <h4 class="appMain--text mb-2">Hello {{ userName }}!</h4>
        <p class="mb-6">
          Track your recruiting activity and stay on top of your outreach goals.
        </p>

        <!-- Contact Search -->
        <recruiting-home-search class="mb-6" />

        <!-- Office Overview -->
        <recruiting-office-overview />

        <!-- Manager Onboarding Video Banner -->
        <recruiting-home-intro-video />

        <!-- Manager Help Links -->
        <recruiting-home-help />
      </div>
    </div>
  </page-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import RecruitingHomeHelp from './components/RecruitingHomeHelp.vue';
import RecruitingHomeIntroVideo from './components/RecruitingHomeIntroVideo.vue';
import RecruitingHomeSearch from './components/RecruitingHomeSearch.vue';
import RecruitingOfficeOverview from './components/RecruitingOfficeOverview.vue';

export default {
  name: 'RecruitingHome',
  components: {
    RecruitingHomeHelp,
    RecruitingHomeIntroVideo,
    RecruitingHomeSearch,
    RecruitingOfficeOverview,
  },
  computed: {
    ...mapGetters('users', ['currentUser', 'currentUserLoaded']),

    userName() {
      return this.currentUser?.first_name || '';
    },
  },
};
</script>
